/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftCancelInput } from "../../entities/models/ShiftCancelInput";
import { z } from "zod/v4";

export const modelsShiftCancelInputSchema = z.object({
    "shift_id": z.int()
    }) as unknown as z.ZodType<ModelsShiftCancelInput>